var Education = "Educación";
var Enterprise = "Enterprise";
var CompanyType = {
	"Company type": "Tipo de empresa",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Gobierno - Federal o regional",
	"Government - State & local": "Gobierno - Estatal y local",
	"Non-profit": "Organización sin fines de lucro",
	"Self employed": "Trabajadores autónomos",
	"Small-medium business": "Pequeña y mediana empresa",
	"Start-up": "Startup",
	"Not applicable": "No procede"
};

export { Education, Enterprise, CompanyType as default };
